import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 px-4" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-16">
          {/* Para ti */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-slate-900 border border-slate-800 rounded-3xl p-8 shadow-lg" data-id="element-17">
            <div className="flex items-center gap-3 mb-8" data-id="element-18">
              <div className="p-2 bg-blue-500/20 rounded-lg" data-id="element-19">
                <Check className="w-6 h-6 text-blue-500" data-id="element-20" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-21">
                ESTO ES PARA TI SI...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-22">
              {['Tienes entre 35 y 65+ años y has notado una pérdida de firmeza.', 'Quieres dejar de depender de fármacos caros y peligrosos.', 'Sientes ansiedad antes de un encuentro debido a fallos anteriores.', 'Buscas una solución discreta que puedes hacer solo y en pocos minutos.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-23">
                  <Check className="w-5 h-5 text-blue-500 shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-slate-300" data-id="element-25">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-slate-950 border border-slate-800 rounded-3xl p-8 shadow-lg opacity-80" data-id="element-26">
            <div className="flex items-center gap-3 mb-8" data-id="element-27">
              <div className="p-2 bg-slate-800 rounded-lg" data-id="element-28">
                <X className="w-6 h-6 text-slate-500" data-id="element-29" />
              </div>
              <h3 className="text-2xl font-bold text-slate-400" data-id="element-30">
                ESTO NO ES PARA TI SI...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-31">
              {['Buscas una pócima mágica que no requiera esfuerzo físico de tu parte.', 'Tienes una condición médica severa que prohíbe cualquier actividad física.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-32">
                  <X className="w-5 h-5 text-slate-600 shrink-0 mt-0.5" data-id="element-33" />
                  <span className="text-slate-400" data-id="element-34">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}